
/**
 * 결제 수단 정보 (단순화된 구조)
 */
export type GetCards200ResponseCardsItem = {
  /** 카드사명 */
  cardName: string;
  /** 마스킹된 카드 번호 */
  cardNumber: string;
  /** 등록일시 */
  createdAt?: string;
  /** 결제 수단 ID (내부 ID, billingKey 아님) */
  paymentMethodId: string;
};
